import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import {
  FailedMessagesPartnerModel,
  FailedMessagesProfileItemModel,
} from '../../models/profile/failed-messages-profile-item.model';
import { FailedMessagesProfileItemBriefState } from './failed-messages-profile-item-brief.state';
import {
  FailedMessagesProfileItemBriefLoad,
  FailedMessagesProfileItemBriefUpdate,
  FailedMessagesProfileItemBriefDelete,
  FailedMessagesProfileItemBriefInitialState,
  FailedMessagesProfileItemBriefPartnerListLoad,
} from './failed-messages-profile-item-brief.actions';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileItemBriefFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(FailedMessagesProfileItemBriefState.getProfileId);
  profile$: Observable<FailedMessagesProfileItemModel> = this.store.select(
    FailedMessagesProfileItemBriefState.getProfile,
  );
  partners$: Observable<FailedMessagesPartnerModel[]> = this.store.select(
    FailedMessagesProfileItemBriefState.getPartners,
  );
  loaded$: Observable<boolean> = this.store.select(FailedMessagesProfileItemBriefState.getLoaded);
  deletedProfileId$: ReplaySubject<number> = new ReplaySubject<number>();

  constructor(private store: Store, private actions: Actions) {}

  loadAll(profileId: number): void {
    this.store.dispatch(new FailedMessagesProfileItemBriefLoad(profileId));
  }

  loadPartners(serviceId: string): void {
    this.store.dispatch(new FailedMessagesProfileItemBriefPartnerListLoad(serviceId));
  }

  updateProfile(profile: FailedMessagesProfileItemModel): void {
    this.store.dispatch(new FailedMessagesProfileItemBriefUpdate(profile));
  }

  deleteProfile(profileId: number): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new FailedMessagesProfileItemBriefDelete(profileId));

    this.deletedProfileId$.next(profileId);
    return this.actions.pipe(ofActionCompleted(FailedMessagesProfileItemBriefDelete));
  }

  setInitialState(): void {
    this.store.dispatch(new FailedMessagesProfileItemBriefInitialState());
  }
}
